import React from 'react'
import ButtonGroup from '@components/button-group'
import Column from '@components/column'
import Image from '@components/image'
import RichText from '@components/rich-text'
import Subnav from '../sub-nav'

const Hero = ({
	heading = "",
	headingElement: HeadingElement = "h2",
	intro,
	bgImage,
	mobileBgImage,
	ctaList = [],
	style = {
		container: '',
		column: '',
		heading: '',
		intro: ''
	},
	isSlider = false,
	isPageHeader = false,
	isCentered = true,
	items,
	activeSlug,
	fromHeroSlider = false
}) => {
	return (
		<div className={`flex flex-col relative rounded-xl h-full ${isSlider ? 'mx-[5px] lg:mx-2.5 ' : 'w-full'} overflow-hidden ${style?.container ? style?.container : ''}`}>
			<Image image={bgImage} maxWidth={1800} className={`${mobileBgImage ? 'max-md:hidden' : ''}`} loading="eager" />
			{mobileBgImage && <Image image={mobileBgImage} maxWidth={700} className={'md:hidden'} />}
			<Column
				className={`${isSlider || isPageHeader ? "absolute right-0 left-0 bottom-0" : ""} box-border flex md:flex-row flex-col justify-between items-start lg:items-end ${style?.column ? style?.column : ''}`}
				innerClassName={`${isCentered ? '!justify-end md:!justify-center items-center' : 'min-md:items-end min-md:!flex-row'}`}
			>
				{bgImage && <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[rgba(0,0,0,0)] via-[rgba(0,0,0,0)] to-[rgba(0,0,0,0.4)] "></div>}
				<div className={`container flex flex-col ${fromHeroSlider? `md:flex-row gap-4 md:gap-8` : "justify-between items-center gap-2 md:gap-5"} flex-between pb-0 md:pb-6`}>
					{heading &&
						<HeadingElement aria-label={heading.replace(/\n/g, ' ')} className={`relative headline flex tracking-tight md:tracking-wide ${style?.heading ? style?.heading : ''} ${bgImage ? 'text-white' : 'text-dark-navy'} ${fromHeroSlider ? "pl-0 md:pl-10" : ""}`} dangerouslySetInnerHTML={{ __html: heading.replace(/\n/g, '<br>') }}></HeadingElement>}
					{intro &&
						<RichText childrenHTML={intro} className={`relative leading-5 flex justify-center text-center text-16 leading-120 ${bgImage ? 'text-white' : 'text-dark-navy'} ${fromHeroSlider ? "pl-0 md:pl-10" : ""}`} paragraphClassName={`${style.intro ? style.intro : 'text-lg'}`} removeOtherClasses={true}></RichText>}
					<ButtonGroup isFullWidth={false} list={ctaList} className={`relative ${fromHeroSlider ? "pr-0 md:pr-10" : ""}`} hasAriaLabel={true} />
					{items && <Subnav items={items} activeSlug={activeSlug} />}
				</div>
			</Column>
		</div>
	)
}

export default Hero